<script>
	export let cls = null
	export let id = null
</script>

<div
	{id}
	class="
    {cls ?? ''}
    mx-auto
    w-wrapper
    max-w-full
    "
>
	<slot />
</div>
